export enum ErrorCode {
  INVALID_VERIFICATION_TOKEN = 'INVALID_TOKEN',
  VERIFICATION_TOKEN_EXPIRED = 'TOKEN_EXPIRED',
}
